"use client";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import { RENEW_PERMISSIONS } from "@/constants/modules.permissions";
import ROUTE_URLS from "@/constants/route-urls";
import useAuth from "@/contexts/auth-context";
import useLanguage from "@/contexts/language-context";
import { RenewMessages } from "@/messages/renew/renew.messages";

import PersonalDataForm from "./components/PersonalDataForm";
import { SubscribeFormData } from "./types";

type Props = {
  messages: RenewMessages;
  isLoading: boolean;
};

function RenewFormCard({ messages, isLoading }: Props) {
  const { submitForm, isValid } = useFormikContext<SubscribeFormData>();
  const { checkPermissions } = useAuth();
  const router = useNavigate();
  const { lang } = useLanguage();

  const hasNoPermissionToRenew = checkPermissions(RENEW_PERMISSIONS.CREATE);

  useEffect(() => {
    if (hasNoPermissionToRenew) {
      router(ROUTE_URLS.serviceDashboard(lang));
    }
  }, [hasNoPermissionToRenew, lang, router]);

  return (
    <Card sx={{ height: "100%" }}>
      <Grid container spacing={3}>
        <PersonalDataForm messages={messages} />
      </Grid>

      <MDBox>
        <Grid container spacing={3} alignItems="center">
          <Grid size={12}>
            <MDBox display="flex" justifyContent="center" gap={2} py={2}>
              <MDButton
                variant="gradient"
                color="dark"
                isLoading={isLoading}
                onClick={submitForm}
                disabled={!isValid || hasNoPermissionToRenew}
              >
                {messages.payButtonLabel}
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default RenewFormCard;
